<template>
    <div v-bind:class="checkSchedule" class="schedule-list">
        <a v-if="checkDelay() && scheduleMobile && call" class="schedule-content" :href="'tel:' + this.experienceContent.phone">
            <div class="schedule-image">
                <img v-if="this.getDesign() == 'black'" src="./../assets/phone_dark.png" alt="">
                <img v-else src="./../assets/phone_white.png" alt="">
                <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
            </div>
            <div class="schedule-text">{{ $t('call') }}</div>
        </a>

        <div v-else-if="checkDelay() && scheduleDesktop && call" class="schedule-content" @click="openModal = !openModal">
            <div class="schedule-image">
                <img v-if="this.getDesign() == 'black'" src="./../assets/phone_dark.png" alt="">
                <img v-else src="./../assets/phone_white.png" alt="">
                <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
            </div>
            <div class="schedule-text">{{ $t('call') }}</div>
        </div>
        <div class="schedule-content" v-else-if="checkPassDay()">
            <div class="schedule-image">
                <img src="./../assets/clock_ocupada.png" alt="">
                <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
            </div>
            <div class="schedule-text">{{ $t('reserved') }}</div>
        </div>
        <div class="schedule-content reserved2-test" @click="selectSchedule(checkSchedule.block)" v-else>
            <div class="schedule-image">
                <img v-if="!checkSchedule.free" src="./../assets/clock_ocupada.png" alt="">
                <img v-else-if="this.getDesign() == 'black'" src="./../assets/clock_dark.png" alt="">
                <img v-else src="./../assets/clock_white.png" alt="">
                <span>{{ this.schedule.start_session.slice(0, -3) }}</span>
            </div>
            <div class="schedule-text" v-if="checkSchedule.block">{{ $t('reserved') }}</div>
            <div class="schedule-text" v-else-if="placesLeft">{{ $tc('placesLeft', placesLeft, { n: placesLeft }) }}</div>
            <div class="schedule-text" v-else>{{ $t('reserve') }}</div>
        </div>

        <div v-if="openModal" class="modal-call" @click="openModal = !openModal">
            <div class="modal-call-center">
                {{ $t('callTo') }} {{ this.experienceContent.phone }} {{ $t('callTo2') }}
            </div>
        </div>
    </div>
</template>

<script>

    import schedule from './../schedule';

    export default {
        extends: schedule,
        name: 'schedule-list'
    };

</script>

<style lang="scss" scoped>

    @import "@/scss/_variables.scss";
    @import "@/scss/_variables_white.scss";
    @import "@/scss/_variables_dark.scss";

    @import "schedule-list";
</style>